/** Matching background colour for banner artwork: average of the image's edge pixels, darkened for white text. No blur. */
const cache = new Map();

export const darken = (hex, amt = 0.28) => {
  const n = parseInt(hex.slice(1), 16); const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  const f = (c) => Math.round(c * (1 - amt)).toString(16).padStart(2, "0");
  return `#${f(r)}${f(g)}${f(b)}`;
};

export const edgeColor = (src) => {
  if (!src) return Promise.resolve(null);
  if (cache.has(src)) return cache.get(src);
  const p = new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const S = 40, c = document.createElement("canvas"); c.width = S; c.height = S;
        const ctx = c.getContext("2d", { willReadFrequently: true }); ctx.drawImage(img, 0, 0, S, S);
        const d = ctx.getImageData(0, 0, S, S).data;
        let r = 0, g = 0, b = 0, n = 0;
        for (let y = 0; y < S; y++) for (let x = 0; x < S; x++) {
          if (x > 2 && x < S - 3 && y > 2 && y < S - 3) continue; // edge ring only — matches the artwork's own border
          const i = (y * S + x) * 4; if (d[i + 3] < 200) continue;
          r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
        }
        if (!n) return resolve(null);
        const hex = `#${[r, g, b].map((v) => Math.round(v / n).toString(16).padStart(2, "0")).join("")}`;
        resolve(hex);
      } catch { resolve(null); } // tainted canvas (cross-origin image) → caller falls back to brand colour
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
  cache.set(src, p);
  return p;
};
